export const listSocial = [
  "Website",
  "Youtube",
  "Twitter",
  "Facebook",
  "Instagram",
  "Vimeo",
  "Linkedin",
  "Whatsapp",
  "Phone",
  "Email",
];

export const listIcons = {
  website: "fas fa-globe",
  youtube: "fab fa-youtube",
  twitter: "fab fa-twitter",
  facebook: "fab fa-facebook-f",
  instagram: "fab fa-instagram-square",
  vimeo: "fab fa-vimeo-v",
  linkedin: "fab fa-linkedin-in",
  whatsapp: "fab fa-whatsapp-square",
  phone: "fas fa-phone-alt",
  email: "fas fa-envelope",
};
